module.exports = __webpack_public_path__ + "static/img_1146-8898c5579c18ca446630d38dc5847bab.webp";